import React from 'react'
import { Icon, RowFlexDiv } from '../Common/CommonStyle'
// import Slider, { Range } from 'rc-slider'
import 'rc-slider/assets/index.css'
import styled from 'styled-components'
import Slider from '../Common/Slider'

// import { alpha, styled } from '@mui/material/styles'

const ZoomTab = ({
  zoomView = { zoomView },
  setZoomView = { setZoomView },
}) => {
  return (
    <RowFlexDiv width='100%' height='100%'>
      <Slider zoomView={zoomView} setZoomView={setZoomView} />
    </RowFlexDiv>
  )
}

export default ZoomTab
